import { inject } from '@angular/core';
import { CanMatchFn, Route, Router } from '@angular/router';

import { UserStateService } from '@core/services/authApiService/user-state-service.service';
import { UserRoles } from '@core/consts/userRoles';

export const roleGuard: CanMatchFn = (route: Route) => {
  const userState = inject(UserStateService);
  const router = inject(Router);

  const requiredRoles: UserRoles[] = route.data?.['roles'] ?? [];
  const userRole = userState.role() as UserRoles;

  if (requiredRoles.includes(userRole)) {
    return true;
  }

  return router.createUrlTree(['/forbidden']);
};
